import { createFileRoute } from '@tanstack/react-router';
import { FriendsPage } from '@/page/FriendsPage';

export const Route = createFileRoute('/_app/friends')({ component: FriendsPage });
